import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
export const NAMESPACE = "projects";
export const FULL_NAMESPACE = createNamespace(NAMESPACE);
